import { Component, OnInit, ChangeDetectorRef, NgZone, OnDestroy } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CroudMarqueCategoryComponent } from '../croud-marque-category/croud-marque-category.component';
import { MarqueService } from '../../../../services/categorie-unite-marque/marque.service';
import { Marque } from '../../../../models/marque';
import { Subscription } from 'rxjs';
import {ParametreService} from '../../main-parametre/parametre.service';

@Component({
    selector: 'app-parametre-marque',
    templateUrl: './parametre-marque.component.html',
    styleUrls: ['./parametre-marque.component.scss']
})
export class ParametreMarqueComponent implements OnInit, OnDestroy {
    marques: Marque[] = [];
    idStation: number = 0;
    idUser: number = 0;
    isLoading: boolean = false;
    private addItemSubscription: Subscription | null = null;

    constructor(
        private marqueService: MarqueService,
        private toastr: ToastrService,
        private router: Router,
        private modalService: NgbModal,
        private cdr: ChangeDetectorRef,
        private ngZone: NgZone,
        private parametreService: ParametreService
    ) {}

    ngOnInit(): void {
        this.loadUserData();
        this.addItemSubscription = this.parametreService.addItem$.subscribe(event => {
          //  console.log('addItem$ triggered:', event);
            if (event.subType === 'marque') {
                this.addMarque(event.idStation);
            }
        });
    }

    ngOnDestroy(): void {
        if (this.addItemSubscription) {
            //console.log('Unsubscribing addItemSubscription');
            this.addItemSubscription.unsubscribe();
        }
    }

    loadUserData(): void {
        const user = localStorage.getItem('currentUser');
        if (user) {
            const currentUser = JSON.parse(user);
           // console.log('Current User:', currentUser);
            this.idUser = currentUser?.id || 0;
            if (currentUser?.stations?.length > 0) {
                this.idStation = currentUser.stations[0].id;
               // console.log('User ID:', this.idUser, 'Station ID:', this.idStation);
                this.loadMarques();
            } else {
                this.toastr.error('Aucune station trouvée. Veuillez créer une station.', 'Erreur');
                this.router.navigate(['/create-station']);
            }
        } else {
            this.toastr.error('Utilisateur non connecté.', 'Erreur');
            this.router.navigate(['/pages/authentication/login-v2']);
        }
    }

    loadMarques(): void {
        if (this.idUser && this.idStation) {
            this.isLoading = true;
            this.marqueService.getAll(this.idStation, this.idUser).subscribe({
                next: (marques) => {
                    this.marques = [...marques];
                    this.isLoading = false;
                   // console.log('Marques loaded:', this.marques);
                    if (marques.length === 0) {
                        //this.toastr.info('Aucune marque trouvée pour cette station.', 'Information');
                    }
                    this.cdr.detectChanges();
                },
                error: (error) => {
                    this.isLoading = false;
                   // console.error('API Error:', error);
                    this.toastr.error(error.message || 'Erreur lors du chargement des marques.', 'Erreur');
                }
            });
        } else {
            this.toastr.error('Informations utilisateur ou station manquantes.', 'Erreur');
        }
    }

    addMarque(idStation: number): void {
        this.idStation = idStation || this.idStation;
       // console.log('Opening modal for addMarque, idStation:', this.idStation, 'ID:', Date.now());
        const modalRef = this.modalService.open(CroudMarqueCategoryComponent, {
            size: 'lg',
            centered: true,
            backdrop: 'static',
            keyboard: false
        });
        modalRef.componentInstance.modalSubType = 'marque';
        modalRef.componentInstance.idStation = this.idStation;
        modalRef.result.then(
            (newMarque: Marque) => {
                this.ngZone.run(() => {
                  //  console.log('Received new marque in addMarque:', newMarque);
                  /*  console.log('Is newMarque valid?', {
                        hasLibelle: !!newMarque.libelle,
                        hasId: !!newMarque.id,
                        idNonZero: newMarque.id > 0
                    });*/
                    if (newMarque && newMarque.libelle && newMarque.id > 0) {
                        this.marques = [newMarque, ...this.marques];
                       // console.log('Updated marques:', this.marques);
                        setTimeout(() => {
                            this.cdr.detectChanges();
                          //  console.log('Change detection triggered');
                        }, 0);
                    } else {
                      //  console.warn('Invalid marque received:', newMarque);
                        this.toastr.warning('Marque non ajoutée localement, actualisation de la liste.', 'Avertissement');
                        this.loadMarques();
                    }
                });
            },
            (reason) => {
                this.ngZone.run(() => {
                   // console.log('Modal dismissed:', reason);
                    if (reason === 'Erreur lors de l\'enregistrement') {
                        this.toastr.error('Erreur lors de l\'ajout, actualisation de la liste.', 'Erreur');
                        this.loadMarques();
                    }
                });
            }
        ).catch((error) => {
           // console.error('Modal promise error:', error);
            this.ngZone.run(() => {
                this.toastr.error('Erreur inattendue lors de la fermeture du modal.', 'Erreur');
                this.loadMarques();
            });
        });
    }

    editMarque(marque: Marque): void {
       // console.log('Opening modal for editMarque, marque:', marque, 'ID:', Date.now());
        const modalRef = this.modalService.open(CroudMarqueCategoryComponent, {
            size: 'lg',
            centered: true,
            backdrop: 'static',
            keyboard: false
        });
        modalRef.componentInstance.modalSubType = 'marque';
        modalRef.componentInstance.idStation = this.idStation;
        modalRef.componentInstance.existingData = { ...marque };
        modalRef.componentInstance.isEditMode = true;
        modalRef.result.then(
            (updatedMarque: Marque) => {
                this.ngZone.run(() => {
                   // console.log('Received updated marque in editMarque:', updatedMarque);
                    /*console.log('Is updatedMarque valid?', {
                        hasLibelle: !!updatedMarque.libelle,
                        hasId: !!updatedMarque.id,
                        idNonZero: updatedMarque.id > 0
                    });*/
                    if (updatedMarque && updatedMarque.libelle && updatedMarque.id > 0) {
                        this.marques = this.marques.map(m =>
                            m.id === updatedMarque.id ? updatedMarque : m
                        );
                       // console.log('Updated marques:', this.marques);
                        this.toastr.success('Marque mise à jour !', 'Succès');
                        setTimeout(() => {
                            this.cdr.detectChanges();
                          //  console.log('Change detection triggered');
                        }, 0);
                    } else {
                        console.warn('Invalid marque received:', updatedMarque);
                        this.toastr.warning('Marque non mise à jour localement, actualisation de la liste.', 'Avertissement');
                        this.loadMarques();
                    }
                });
            },
            (reason) => {
                this.ngZone.run(() => {
                   // console.log('Modal dismissed:', reason);
                    if (reason === 'Erreur lors de l\'enregistrement') {
                        this.toastr.error('Erreur lors de la mise à jour, actualisation de la liste.', 'Erreur');
                        this.loadMarques();
                    }
                });
            }
        ).catch((error) => {
            console.error('Modal promise error:', error);
            this.ngZone.run(() => {
                this.toastr.error('Erreur inattendue lors de la fermeture du modal.', 'Erreur');
                this.loadMarques();
            });
        });
    }
}
